// Filter store
import mutations from './mutations';
import actions from './actions';

// Initial state
const state = {
  libraryPath: '/library',
};

export default {
  actions,
  mutations,
  state,
};
